import React from "react";

const Hero = () => (
	<section className="bg-[#ff7200] text-white py-24 text-center">
		<div className="max-w-5xl mx-auto px-4">
			<h2 className="text-5xl font-extrabold mb-4">
				Facility & IT Services You Can Trust
			</h2>
			<p className="text-xl text-white/90 mb-6">
				Family Depot Limited delivers exceptional Facility Management and IT
				Solutions across industries.
			</p>
			<a
				href="#contact"
				className="bg-white text-[#ff7200] px-6 py-3 rounded font-semibold hover:bg-gray-100"
			>
				Contact Us
			</a>
		</div>
	</section>
);

export default Hero;
